export function FieldError({ message }: { message?: string }) {
  if (message === undefined || message === '') return null
  return (
    <div role="alert" style={{ color: 'var(--negative)', fontSize: 12, marginTop: 'var(--o-space-2)' }}>
      {message}
    </div>
  )
}

export function FormError({ message }: { message: string | null }) {
  if (message === null) return null
  return (
    <div
      role="alert"
      style={{
        background: 'var(--negative-bg)',
        color: 'var(--negative)',
        borderRadius: 'var(--r-md)',
        padding: 'var(--o-space-3) var(--o-space-4)',
        marginBottom: 'var(--o-space-4)',
        fontSize: 13,
      }}
    >
      {message}
    </div>
  )
}
